import * as React from "react";
const NewsCross = (props) => (
  <svg
    width={17}
    height={19}
    viewBox="0 0 17 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 2L1 17"
      stroke="#CED5E5"
      strokeWidth={2}
      strokeLinecap="round"
    />
    <path
      d="M1 2L16 16.0625"
      stroke="#CED5E5"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);
export default NewsCross;
